// extracted by mini-css-extract-plugin
module.exports = {"white_color":"#fff","orange_color":"#ff9534","gray_color":"#e0e0e0"};